
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import DocAccessibilityForm from "../../components/DocAccessibilityForm";
import DocList from "../../components/DocAccessList";
import HelperAccordion from "../../components/helperAccordion";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import AVAccessibilityForm from "../../components/AvAccessForm";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import AccessibilityHelperModal from "../../components/accessibilityHelper";

function AVAccessNew() {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
      
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);


  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  const docContainerRef = useRef<HTMLInputElement>(null);
  
  enum pages {
    one,
    two,
    three,
  }

  const toggleToPrevReq = () => {
    navigate('/avaccess');
  }

  // const [activePage, setActivePage] = useState("1");
  // const [activeService,setActiveService] = useState('');
  // const [model,setModel] = useState('');

  // const handleLinkClick = (page: React.SetStateAction<string>) => {
  //   setActivePage(page);
  // };
  useEffect(()=>{
    if(localStorage.getItem('token')===null || localStorage.getItem('token')===undefined){
        navigate('/login');
      }
      if (docContainerRef.current) {
        docContainerRef.current.focus();
      }
    document.title = 'Audio Video Accessibility Request - Nclude Portal'
  },[])

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);
  
  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header activePage='av' curr={0}/>}
      <div className="page-container">
        <SideBar activePage="avAccessibility"/>
        {isMobile && <header className="mobile-header">
      <div className="accessibility-header" id="accessibility-menu" tabIndex={-1}>
        <div tabIndex={0} className="active-accessibility-header">{'Convert Media'}</div>
        <button type="button" tabIndex={0} onClick={()=> toggleToPrevReq()}>Previous Requests</button>
      </div>  
    </header>}
        <div className="doc-container" role="main" tabIndex={-1} style={{ paddingTop: isMobile?"2rem":""}}>
          <h1 className="display-title" ref={mainRef} tabIndex={-1}>Audio/Video Accessibility</h1>
          <a className="sr-only"
             tabIndex={0}
            href="#accessibility-menu"
            >To move to audio-video accessibility menu press enter</a>
          <p className="accessibility-helper">To know how this service of converting audio and video works, please 
             <span 
             className="click"
            style={{ color: '#5030E5',cursor:'pointer' }}
            onClick={()=> handleShow()}
            >
               {' click here'}
            </span></p>
            <AccessibilityHelperModal 
            show={show} 
            handleClose={handleClose} 
            parent={'av'}
            aria-labelledby="accessibility-helper-title"
            aria-describedby="accessibility-helper-description"
            />
          <div className="component-container form-container upload-form-container">
            <AVAccessibilityForm />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AVAccessNew;
